/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useEffect } from 'react'
import { Text } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  PaginationStyled,
  PaginationNavStyled,
  PaginationListStyled,
  PaginationListItemStyled,
  PaginationListItemLinkStyled
} from './styles'
import { PaginationProps } from './types'

import { IconArrowSmall } from './../../../assets/svg/index'

const Pagination: React.FC<PaginationProps> = ({ currentPage, postsPerPage, totalPosts, paginate }) => {
  const isDesktop = useResponsiveValue([false, false, true, true], {
    defaultIndex: 0
  })

  const pageNumbers = []

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i)
  }

  useEffect(() => {
    if (totalPosts < postsPerPage) {
      paginate(1)
    } else {
      return
    }
  })

  return (
    <PaginationStyled>
      {pageNumbers.length ? (
        <PaginationNavStyled onClick={() => paginate(currentPage - 1)} isInactive={currentPage === 1}>
          {isDesktop ? <Text variant="bodyMontserrat2">Previous</Text> : <IconArrowSmall />}
        </PaginationNavStyled>
      ) : (
        ''
      )}
      <PaginationListStyled>
        {pageNumbers.map((number) => (
          <PaginationListItemStyled key={number} isActive={number === currentPage}>
            <PaginationListItemLinkStyled onClick={() => paginate(number)}>{number}</PaginationListItemLinkStyled>
          </PaginationListItemStyled>
        ))}
      </PaginationListStyled>
      {pageNumbers.length ? (
        <PaginationNavStyled onClick={() => paginate(currentPage + 1)} isInactive={currentPage === pageNumbers[pageNumbers.length - 1]}>
          {isDesktop ? (
            <Text variant="bodyMontserrat2">Next</Text>
          ) : (
            <IconArrowSmall
              sx={{
                transform: 'rotate(180deg)'
              }}
            />
          )}
        </PaginationNavStyled>
      ) : (
        ''
      )}
    </PaginationStyled>
  )
}

export default Pagination
